<div>
    <div style="text-align: center;">
      <br>
      <h3><b>{{data.message}}</b></h3>
    </div>
  
    <div style="align-content: center;">
      <div style="padding: 3%;">
        <div>
          <div class="d-flex w-100 justify-content-left">
            <input [(ngModel)]="balancesCero" (click)="addValue($event)" type="checkbox" style="width: 20px; height: 20px;"/>
            &nbsp;Deja todos los Balances en Cero (0)
          </div>
          <br/>
          <div class="d-flex w-100 justify-content-center-left">
            <input [(ngModel)]="contadoresCero" (click)="addValue($event)" type="checkbox" style="width: 20px; height: 20px;"/>
            &nbsp;Deja todos los Contadores de Atraso en Cero (0)
          </div>
          <hr/>
        </div>
      </div>
    </div>
  
    <div>
      <div class="d-flex w-100 justify-content-center">
        <button class="efx-button-secondary button-secondary" (click)="onNoClick()">{{data.onCancelText === undefined ? 'Cancelar' : data.onSubmitText}}</button>&nbsp;
        <button class="efx-button-primary button-primary" (click)="onSubmit()" cdkFocusInitial
          [disabled]="btnStatus">{{data.onSubmitText === undefined ? 'Seleccionar' : data.onSubmitText}}</button>
      </div>
      <br>
    </div>
  </div>
  